export function scrollToNotValidField(formErrors, containerBlock, isSingleForm) {
  let firstProp;
  for (let prop in formErrors) {
    firstProp = prop;
    break;
  }
  let container = $(`${containerBlock}`);

  function extractAfterNumberDot(str) {
    let match = str.match(/\d+\.(.+)/);
    return match ? match[1] : null;
  }

  if (isSingleForm) {
    firstProp = extractAfterNumberDot(firstProp);
  }

  if (firstProp == 'agree') {
    container.animate({ scrollTop: 9999 }, 'slow');
  } else {
    let elem = $(`${containerBlock} #${firstProp}`);

    if (!elem || !elem.length) {
      elem = $(`${containerBlock} label[for="${firstProp}"]`);
    }
    if (!elem || !elem.length) {
      elem = $(`${containerBlock} label[for="${firstProp}_option-1"]`);
    }
    if (!elem || !elem.length) {
      elem = $(`${containerBlock} label[for="${firstProp}[]"]`);
    }

    if (elem && elem.length) {
      const pos = elem.position().top + container.scrollTop() - container.position().top - 40;
      container.animate({ scrollTop: pos }, 'slow');
    } else {
      container.animate({ scrollTop: 9999 }, 'slow');
    }
  }
}
